import { config } from '../config';
import { apiRequest } from './client';

const base = config.platformApiUrl;

export const platformApi = {
  listShops: (token) => apiRequest(base, '/api/v1/shops', { token }),
  getShop: (token, shopId) => apiRequest(base, `/api/v1/shops/${shopId}`, { token }),
  updateShop: (token, shopId, payload) =>
    apiRequest(base, `/api/v1/shops/${shopId}`, { token, method: 'PATCH', body: payload }),
  deleteShop: (token, shopId) =>
    apiRequest(base, `/api/v1/shops/${shopId}`, { token, method: 'DELETE' }),
  listShopAdmins: (token, shopId) =>
    apiRequest(base, `/api/v1/shops/${shopId}/admins`, { token }),
  assignShopAdmin: (token, shopId, payload) =>
    apiRequest(base, `/api/v1/shops/${shopId}/admins`, {
      token,
      method: 'POST',
      body: payload,
    }),
  removeShopAdmin: (token, shopId, userId) =>
    apiRequest(base, `/api/v1/shops/${shopId}/admins/${userId}`, {
      token,
      method: 'DELETE',
    }),
  listStaff: (token) => apiRequest(base, '/api/v1/staff', { token }),
  createStaff: (token, payload) =>
    apiRequest(base, '/api/v1/staff', { token, method: 'POST', body: payload }),
  deactivateStaff: (token, userId) =>
    apiRequest(base, `/api/v1/staff/${userId}`, { token, method: 'DELETE' }),
};
